import React from 'react';
import getConfig from 'next/config';
import dynamic from 'next/dynamic';
import { CollapsibleAccordionBox, UserInfoTitle } from '../../components';
import Footer from '../homepage/Footer/Footer';
import { TERMS_AND_CONDITION_CONSTANT } from '../../shared/terms_and_condition';
import './TermsContainer.sass';

const Meta = dynamic(() => import('../../components/Meta'));
const { APP_ENV } = getConfig().publicRuntimeConfig;

const TermsContainer = () => {
  return (
    <>
      <Meta
        title="Syarat dan Ketentuan – Lifepal"
        meta={[
          <meta
            key="description"
            name="description"
            content="Pelajari informasi lebih lanjut mengenai syarat dan ketentuan penggunaan situs web Lifepal."
          />,
          <link
            key="canonical"
            rel="canonical"
            href={APP_ENV === 'production' ? 'https://lifepal.co.id/ketentuan/' : 'https://lifepal.tech/ketentuan/'}
          />
        ]}
      />
      <UserInfoTitle title="Syarat dan Ketentuan" />
      <div className="privacy--container">
        <div className="privacy__content--container">
          {TERMS_AND_CONDITION_CONSTANT.map((policy, index) => (<CollapsibleAccordionBox policy={policy} key={index} />))}
        </div>
      </div>
      
      <div className="privacy--container">
        <div className="privacy__content--container">
          <p>
            <strong>Diperbarui pada : Maret 2026</strong>
          </p>
        </div>
      </div>
      {/* when footer from design-system updated, remove this implementation */}

      <Footer />
    </>
  )
}

export default TermsContainer;
